import { TRANSLATABLE_TRANSACTION_TYPES } from "../enum/transaction";

export var transaction_table = {
  data() {
    return {
      headers: [
        {
          text: this.$t("thead.time"),
          value: "time",
          renderer: "datetime",
          search_type: "text"
        },
        {
          text: this.$t("thead.location"),
          value: "location.name",
          search_type: "text"
        },
        {
          text: this.$t("thead.total_amount"),
          value: "total_price",
          renderer: "currency-cents",
          search_type: "text"
        },
        {
          text: this.$t("thead.type"),
          value: "type",
          renderer: "transaction_type",
          search_type: "text",
          multiple: true,
          choices: TRANSLATABLE_TRANSACTION_TYPES
        }
      ]
    };
  }
};

export var transaction_view = {
  data() {
    return {
      transaction: null,
      headers: [
        {
          text: "Aantal",
          value: "quantity"
        },
        {
          text: "Product",
          value: "product_name"
        },
        {
          text: "Promotie",
          value: "promotion_name"
        },
        {
          text: "Prijs",
          value: "total_price"
        },
        {
          text: "Barcode",
          value: "barcode"
        }
      ],
      payment_headers: [
        {
          text: "Totaal",
          value: "amount"
        },
        {
          text: "Betaalmethode",
          value: "type"
        }
      ],
      prepaid_mutations_headers: [
        {
          text: "Balans",
          value: "balance"
        },
        {
          text: "Verschil",
          value: "delta"
        },
        {
          text: "Nieuwe balans",
          value: "new_balance"
        }
      ]
    };
  },
  async mounted() {
    const transactionId = this.$route.params.id;
    let transaction = this.$store.getters[
      "transactions/user_transactions"
    ].find(item => item.id === transactionId);
    if (transaction === undefined) {
      await this.$store
        .dispatch("transactions/getTransaction", {
          id: transactionId
        })
        .then(response => {
          transaction = response.data;
        })
        .catch(() => {
          this.$store.commit("viewstate/notify", {
            color: "error",
            text: "Transactie kon niet gevonden worden!"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
    this.transaction = transaction;
  }
};
